module.exports = __webpack_public_path__ + "static/img/5.3a134d9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.jpeg
// module id = eCic
// module chunks = 0